exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".access[data-v-7ca188da]{border-collapse:collapse;margin-top:5px}.access th[data-v-7ca188da],.access td[data-v-7ca188da]{border:1px solid #000;padding:5px 10px;text-align:center}", ""]);

